export const APP_SETTINGS = '/apps/:slug'
